import { useContext } from 'react'

import { SnackbarContext, type SnackbarContextInterface } from '../providers/SnackbarProvider'

const useSnackbars: () => SnackbarContextInterface = () => useContext(SnackbarContext)

export default useSnackbars
